/* eslint-disable react-hooks/exhaustive-deps */
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getFormByFormID } from "./fetchData";
import { Toast } from "primereact/toast";
import { ProgressSpinner } from "primereact/progressspinner";
import { Image } from "primereact/image";

const ViewVehicleAssessment = () => {
  const toast = useRef<Toast>(null);
  const ImageNotAvailable = process.env.REACT_APP_IMAGE_NOT_FOUND_URL || "";
  const [formData, setFormData] = useState<any>(null);
  const [formDataLoading, setFormDataLoading] = useState<boolean>(false);
  const navigate = useNavigate();

  const icon = (
    <i
      className="pi pi-eye tw-text-white tw-h-full tw-w-full tw-justify-center tw-items-center tw-flex"
      style={{
        backgroundColor: "black",
        opacity: 0.5,
        transition: "opacity 0.3s ease",
      }}
    ></i>
  );

  const query = new URLSearchParams(window.location.search);
  const formIDParam = Number(query.get("formID"));

  useEffect(() => {
    if (!formIDParam) {
      navigate("/layout/leak-detection/vehicle-assessment-list");
    }
    getFormByFormID(
      setFormData,
      setFormDataLoading,
      formIDParam,
      navigate,
      toast
    );
  }, []);

  // Prepare assessments data
  const assessments = formData?.formJson?.dailyShiftCheck?.checklist?.map(
    (item: any) => ({
      question: item.label,
      status: item.value === true ? "Yes" : "No",
    })
  );

  // Prepare confirmation message
  const confirmationsmessage = [
    {
      element: formData?.formJson?.confirmRoadWorthy?.label,
      status: formData?.formJson?.confirmRoadWorthy?.value ? "Yes" : "No",
    },
  ];

  // Format date from timestamp
  const formatDate = (timestamp: number) => {
    const date = new Date(timestamp * 1000);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  // Helper to get vehicle photo by label
  const getVehiclePhoto = (label: string) => {
    const photo =
      formData?.fileJson?.vehicle &&
      formData?.fileJson?.vehicle?.find((img: any) =>
        img.originalname
          .replace(".png", "")
          .toLowerCase()
          .includes(label.toLowerCase())
      );
    return photo?.file || ImageNotAvailable;
  };

  // Helper to get timestamp and location by photoKey
  const getPhotoMeta = (photoKey: string) => {
    const locationObj = formData?.timeStampLocationJson?.locations?.find(
      (loc: any) => loc.photoKey === photoKey
    );
    const timeObj = formData?.timeStampLocationJson?.timeStamps?.find(
      (t: any) => t.photoKey === photoKey
    );
    return {
      address: locationObj?.address || "",
      timestamp: timeObj?.timestamp || "",
    };
  };

  return (
    <div>
      {formDataLoading ? (
        <div className="tw-h-full tw-w-full tw-bg-transparent tw-flex tw-justify-center tw-items-center tw-absolute tw-top-0 tw-left-[50px] lg:tw-left-[120px] tw-z-50">
          <ProgressSpinner />
        </div>
      ) : (
        <div className="tw-border-solid tw-border tw-border-[#E2E2e2] tw-rounded-lg tw-relative tw-bg-white">
          <div className="tw-bg-[#F8FAFC] tw-p-4 tw-rounded-t-lg tw-border-b-[1px] tw-border-[#E2E8F0] tw-flex tw-justify-between tw-items-center">
            <h2 className="tw-text-2xl tw-font-semibold tw-text-[#101828]">
              Basic Details
            </h2>
          </div>

          <div className="tw-grid tw-grid-cols-1 lg:tw-grid-cols-3  tw-gap-3 tw-px-4 tw-py-4">
            <div className="tw-flex tw-items-center tw-gap-1">
              <p className="leak-detail-label">Date :</p>
              <p className="leak-value">
                {formatDate(formData?.formJson?.date) || null}
              </p>
            </div>
            <div className="tw-flex tw-items-center tw-gap-1">
              <p className="leak-detail-label">Driver Name :</p>
              <p className="leak-value">
                {formData?.formJson?.driver?.displayName || ""}
              </p>
            </div>
            <div className="tw-flex tw-items-center tw-gap-1">
              <p className="leak-detail-label">Vehicle Registration :</p>
              <p className="leak-value">
                {formData?.formJson?.vehicle?.registration_no || ""}
              </p>
            </div>
            <div className="tw-flex tw-items-center tw-gap-1">
              <p className="leak-detail-label">Make :</p>
              <p className="leak-value">
                {formData?.formJson?.vehicle?.make || "N/A"}
              </p>
            </div>

            <div className="tw-flex tw-items-center tw-gap-1">
              <p className="leak-detail-label">Model :</p>
              <p className="leak-value">
                {formData?.formJson?.vehicle?.model || "N/A"}
              </p>
            </div>
            <div className="tw-flex tw-items-center tw-gap-1">
              <p className="leak-detail-label">Mileage :</p>
              <p className="leak-value">
                {formData?.formJson?.vehicle?.mileage}
              </p>
            </div>
          </div>
          {/* daily/shift check */}
          <div className="tw-p-4 tw-border-b-[1px] tw-border-[#E2E8F0]">
            <h2 className="tw-text-lg tw-font-semibold tw-text-[#101828]">
              Daily/Shift Check
            </h2>
          </div>
          <div className="tw-p-4">
            <DataTable value={assessments} className="tw-w-full" showGridlines>
              <Column
                field="question"
                header="Items"
                className="lg:max-w-[400px] max-w-[300px] tw-text-black tw-font-medium "
              />
              <Column
                field="status"
                header=""
                className="tw-text-right tw-font-semibold lg:tw-w-[100px]"
                body={(rowData) => (
                  <span className={`tw-font-medium tw-text-black`}>
                    {rowData.status ?? "N/A"}
                  </span>
                )}
              />
            </DataTable>
          </div>
          {/* defect photographs */}
          <div className="tw-p-4 tw-border-b-[1px] tw-border-[#E2E8F0]">
            {formData?.fileJson?.defectPicture?.length > 0 && (
              <h2 className="tw-text-lg tw-font-semibold tw-text-[#101828]">
                Defect Photographs
              </h2>
            )}
          </div>
          <div className="tw-p-4 tw-grid tw-grid-cols-1 lg:tw-grid-cols-4 tw-gap-2 sm:tw-grid-cols-2">
            {(formData?.fileJson?.defectPicture || []).map(
              (img: any, idx: number) => {
                // Extract photoKey from filename (e.g., "defect-1" from "defect-1.png")
                const photoKey = img.originalname.replace(".png", "");
                const meta = getPhotoMeta(photoKey);
                return (
                  <div className="tw-flex tw-flex-col tw-gap-2" key={img.file}>
                    <p className="leak-detail-label">{`Photograph ${
                      idx + 1
                    }`}</p>
                    <Image
                      src={img.file}
                      alt={`Defect Photograph ${idx + 1}`}
                      className="tw-w-32 tw-shrink-0 tw-object-contain"
                      indicatorIcon={icon}
                      preview
                      loading="lazy"
                      pt={{
                        rotateRightButton: { className: "tw-text-white" },
                        downloadButton: { className: "tw-text-white" },
                        rotateLeftButton: { className: "tw-text-white" },
                        zoomInButton: { className: "tw-text-white" },
                        zoomOutButton: { className: "tw-text-white" },
                        closeButton: { className: "tw-text-white" },
                      }}
                      // header={
                      //   <div className="tw-p-2 tw-bg-black tw-bg-opacity-70 tw-text-white tw-text-center tw-rounded-t">
                      //     {`Photograph ${idx + 1}`}
                      //   </div>
                      // }
                      // downloadable
                      onError={(e) => {
                        (e.target as HTMLImageElement).src = ImageNotAvailable;
                      }}
                    />
                    {(meta.timestamp || meta.address) && (
                      <div className="tw-mt-2">
                        <p className="tw-text-sm tw-text-gray-900">
                          {meta.address}
                        </p>
                        <p className="tw-text-sm tw-text-gray-900">
                          {meta.timestamp}
                        </p>
                      </div>
                    )}
                  </div>
                );
              }
            )}
          </div>

          {/* Additional Comments */}
          {formData?.fileJson?.defectPicture?.length > 0 && (
            <div className="tw-p-4">
              <div>
                <label className="tw-font-medium tw-text-[#344054]">
                  Any Additional Comments:
                </label>
                <p className="tw-text-[#6C6C6C] tw-font-normal">
                  {formData?.formJson?.additionalDefectComments ||
                    "No additional comments"}
                </p>
              </div>
            </div>
          )}

          {/* Vehicle Photographs  */}
          <div className="tw-p-4 tw-border-b-[1px] tw-border-[#E2E8F0]">
            <h2 className="tw-text-lg tw-font-semibold tw-text-[#101828]">
              Vehicle Photographs
            </h2>
          </div>
          <div className="tw-p-4 tw-grid tw-grid-cols-1 lg:tw-grid-cols-5 tw-gap-2 sm:tw-grid-cols-2">
            {[
              {
                label: "front-driver",
                display: "Exterior - Front Driver Side",
              },
              {
                label: "front-passenger",
                display: "Exterior - Front Passenger Side",
              },
              { label: "dashboard", display: "Dashboard" },
              {
                label: "vehicle-front-cabin-interior",
                display: "Vehicle Front Cabin Interior",
              },
              {
                label: "vehicle-backside-interior",
                display: "Vehicle Backside Interior",
              },
            ].map((item) => {
              const meta = getPhotoMeta(item.label);
              return (
                <div className="tw-flex tw-flex-col tw-gap-2" key={item.label}>
                  <p className="leak-detail-label">{item.display}</p>
                  <div className="tw-min-h-32 tw-relative group">
                    <Image
                      src={getVehiclePhoto(item.label)}
                      preview
                      alt={`Vehicle Photograph ${item.display}`}
                      className="tw-w-32 tw-shrink-0 tw-object-contain"
                      indicatorIcon={icon}
                      loading="lazy"
                      // downloadable
                      pt={{
                        rotateRightButton: { className: "tw-text-white" },
                        downloadButton: { className: "tw-text-white" },
                        rotateLeftButton: { className: "tw-text-white" },
                        zoomInButton: { className: "tw-text-white" },
                        zoomOutButton: { className: "tw-text-white" },
                        closeButton: { className: "tw-text-white" },
                      }}
                      onError={(e) => {
                        (e.target as HTMLImageElement).src = ImageNotAvailable;
                      }}
                    />
                  </div>
                  {(meta.timestamp || meta.address) && (
                    <div className="tw-mt-2">
                      <p className="tw-text-sm tw-text-gray-900">
                        {meta.address}
                      </p>
                      <p className="tw-text-sm tw-text-gray-900">
                        {meta.timestamp}
                      </p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>

          <div className="tw-p-4">
            <DataTable value={confirmationsmessage} className="tw-w-full">
              <Column
                field="element"
                header={<span className="tw-py-3 !tw-h-10"> </span>}
                className="lg:max-w-[400px] max-w-[300px]"
              />
              <Column
                field="status"
                header=""
                className="tw-text-right tw-font-medium tw-text-black"
              />
            </DataTable>
          </div>
          {/* Action Buttons */}
          <div className="tw-flex tw-justify-end tw-items-center tw-p-4 tw-gap-2 !tw-border-t-[#E2E8F0] tw-border-t-[1px]">
            <Button
              className={`tw-flex tw-px-3 tw-py-2 tw-rounded tw-bg-primary tw-border-primary tw-text-white
                   tw-font-medium`}
              label={"Back"}
              onClick={() =>
                navigate("/layout/leak-detection/vehicle-assessment-list")
              }
              color="white"
              icon="pi pi-chevron-left"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default ViewVehicleAssessment;
